import s from './NavHeaderFields.module.scss';

interface NavHeaderFieldsProps {
  shipName: string;
  registrationNumber: string;
  onImoNumber: string;
}

export function NavHeaderFields({
  shipName,
  registrationNumber,
  onImoNumber,
}: NavHeaderFieldsProps) {
  return (
    <div className={s.root}>
      <HeaderCell label="Ship Name" value={shipName} />
      <HeaderCell label="Registration Number/ID" value={registrationNumber} />
      <HeaderCell label="ON/IMO Number" value={onImoNumber} />
    </div>
  );
}

function HeaderCell({ label, value }: { label: string; value: string }) {
  return (
    <div className={s.cell}>
      <span className={s.label}>{label}</span>
      <span className={s.value}>{value || '-'}</span>
    </div>
  );
}
